import styled from 'styled-components';

import { background_01_7x2_a } from '@xing-com/background-images';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXS, space3XL, space4XL, space6XL } from '@xing-com/tokens';

export const Container = styled.div`
  background-image: url(${background_01_7x2_a});
  width: 100%;
  padding: ${space3XL} ${spaceXS};

  @media ${mediaConfined} {
    padding: ${space4XL} ${space6XL};

    & > * {
      max-width: 972px;
      margin: 0 auto;
    }
  }
`;
